module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_8011.5714ea49.png";